// Primary brand colors
export const primaryActionColor = "#6366f1";
export const primaryActionColorLight = "#eef2ff";
export const primaryActionColorDark = "#4f46e5";

// Secondary colors
export const secondaryColor = "#8b5cf6";
export const secondaryColorLight = "#f5f3ff";

// Status colors
export const successColor = "#10b981";
export const successColorLight = "#d1fae5";
export const warningColor = "#f59e0b";
export const warningColorLight = "#fef3c7";
export const dangerColor = "#ef4444";
export const dangerColorLight = "#fee2e2";

// Neutral colors
export const textPrimary = "#1e293b";
export const textSecondary = "#475569";
export const textMuted = "#94a3b8";
export const borderColor = "#e2e8f0";
export const backgroundLight = "#f8fafc";

// Legacy (keeping for compatibility)
export const inputHeight = "40px";
export const inputPadding = "5px 15px";
export const actionButtomBroderRadius = "5px";
export const ADMIN = "/admin/";
export const primaryTextColor = "#1e293b";
export const headerTextColor = "#1e293b";
